/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer components {
  .button {
    text-transform: none;
    &:global(.ant-btn-default:not(:disabled)) {
      color: var(--base-grey-800);
      &:active,	&:hover,	&:focus {
        z-index: 10;
        border-color: var(--color-primary-500);
        color: var(--color-primary-500);
      }
    }
    &:global(.ant-btn-primary) {
      border-color: var(--color-primary-600);
      background-color: var(--color-primary-600);
      &:active,	&:hover,	&:focus {
        border-color: var(--color-primary-500);
        background-color: var(--color-primary-500);
      }
      &:disabled {
        border-color: var(--base-grey-200);
        background-color: var(--base-grey-200);
        color: var(--base-grey-500);
      }
    }
    &:global(.ant-btn-secondary) {
      border-color: var(--color-primary-600);
      background-color: var(--base-white);
      color: var(--color-primary-600);
      &:active,	&:hover,	&:focus {
        border-color: var(--color-primary-500);
        color: var(--color-primary-500);
        path {
          stroke: currentcolor;
          color: var(--color-primary-500);
        }
      }
      &:disabled {
        border-color: var(--base-grey-400);
        background-color: var(--base-grey-200);
        color: var(--base-graphite-400);
      }
    }
    &:global(.ant-btn-link) {
      :where(& > :not(:last-child)) {
        --tw-border-style: none;
        border-style: none;
      }
      background-color: transparent;
      color: var(--color-primary-600);
      --tw-shadow: 0 0 #0000;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      &:active,	&:hover,	&:focus {
        :where(& > :not(:last-child)) {
          --tw-border-style: none;
          border-style: none;
        }
        background-color: transparent;
        color: var(--color-primary-500);
      }
      &[ant-click-animating-without-extra-node]:after {
        content: none;
      }
      &:disabled {
        color: var(--base-graphite-275);
      }
    }
    &:global(.ant-btn-ghost[disabled]) {
      background-color: var(--base-white);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--base-white) 15%, transparent);
      }
    }
    &:global(.ant-btn-tiny) {
      height: 18px;
      padding-inline: 5px;
      font-size: var(--text-11, 0.6875rem);
    }
    & :global(.anticon) {
      display: inline-flex;
    }
  }
  .primary,	.secondary,	.default {
    text-transform: uppercase;
  }
  .dark {
    --tw-border-style: none;
    border-style: none;
    background-color: var(--base-grey-850);
    color: var(--base-grey-100);
    &:hover {
      @media (hover: hover) {
        background-color: var(--base-grey-800);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--base-grey-100);
      }
    }
    &:focus {
      background-color: var(--base-grey-800);
    }
    &:focus {
      color: var(--base-grey-100);
    }
    &:active {
      background-color: var(--base-grey-800);
    }
    &:active {
      color: var(--base-grey-100);
    }
  }
  .layoutInline {
    display: inline;
  }
  .layoutBlock {
    display: block;
    width: 100%;
  }
  .active {
    z-index: 10 !important;
    border-color: var(--color-primary-500) !important;
    color: var(--color-primary-500) !important;
  }
  .compact {
    display: flex;
    height: 23px;
    align-items: center;
    gap: calc(var(--spacing, 0.25rem) * 2);
    padding-inline: calc(var(--spacing, 0.25rem) * 3);
    font-size: var(--text-13, 0.8125rem);
    --tw-leading: 1;
    line-height: 1;
    text-transform: none !important;
    svg {
      font-size: 9px;
    }
  }
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-leading: initial;
    }
  }
}
